import React, { Component } from 'react';
import { func, object, shape, string } from 'prop-types';
import { getSegments } from 'shared/common.api';
import { UserStateContext } from 'context/user-state-context';
import { DynamicTypeAhead } from '../../../../components/dynamic-type-ahead/dynamic-type-ahead.component';
export class ActionRemoveFromSegment extends Component {
  static contextType = UserStateContext;
  static propTypes = {
    update: func,
    node: object,
    data: shape({
      segment_id: string
    })
  };
  state = {
    segmentList: []
  };
  componentDidMount() {
    getSegments({
      company: this.context.asCompany.id,
      time_dynamic_segment: false,
      limit: 200
    }).then(({
      data
    }) => {
      this.setState({
        segmentList: data.results
      });
    });
  }
  toggleSegment = id => {
    const {
      segment_id
    } = this.props.data;
    this.props.update({
      segment_id: !segment_id ? id : segment_id.id !== id ? id : null
    });
  };
  render() {
    const {
      segmentList
    } = this.state;
    const selectedSegment = segmentList.find(segment => segment.id === this.props.data.segment_id);
    return <div>
        <div className="form-group">
          <label>Static Segment</label>
          <DynamicTypeAhead getItems={getSegments} getItemsFilters={{
          company: this.context.asCompany.id,
          time_dynamic_segment: false
        }} placeholder={selectedSegment ? `${selectedSegment.name}` : "Choose Static Segment"} displayProperty="name" keyProperty="id" value={selectedSegment ? selectedSegment.id : null} onChange={segment => {
          this.toggleSegment(segment ? segment.id : null);
        }} />
        </div>
      </div>;
  }
}